export default {
  create_title: 'Cont nou Partner API',
  edit_title: 'Editează contul',
  form: {
    name: 'Nume cont',
    name_placeholder: 'ex. integrare POS Acme',
    contact_email: 'Email de contact',
    scope: 'Acces la restaurante',
    companies: 'Restaurante',
    scope_selected: 'Restaurante selectate',
    scope_all: 'Toate restaurantele',
    scope_all_help:
      'Cheile din acest cont ajung la fiecare restaurant al organizației tale, inclusiv cele înregistrate ulterior.',
    companies_placeholder: 'Selectează restaurante',
    companies_help: 'Cheile emise pe acest cont pot citi și scrie doar aceste restaurante.',
    is_active: 'Activ',
    is_active_help: 'Conturile inactive sunt respinse la autentificare.',
  },
  buttons: {
    cancel: 'Anulează',
    save: 'Salvează',
    create: 'Creează',
  },
  toasts: {
    created: 'Cont Partner API creat.',
    updated: 'Cont actualizat.',
    error: 'Contul nu a putut fi salvat.',
  },
};
